// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"MessageLoader_loaderOverlay__YYs5f","loaderContainer":"MessageLoader_loaderContainer__8j5mw"};